/* eslint no-shadow: 0 */
import { get } from 'lodash';
/* eslint no-param-reassign: ['error', { 'props': false }] */
import {
  initializeBrowseTasks,
  getBrowseTaskSkills,
  getBrowseTaskInterests,
  browseTaskEdit,
} from '@/api';
import {
  GET_BROWSE_ID,
  GET_BROWSE_TASK_SKILLS,
  GET_BROWSE_TASK_INTERESTS,
  BROWSE_LOADER,
} from '@/store/mutation-types';

const state = {
  loading: false,
  browse_id: null,
  skills: [],
  interests: [],
};

const getters = {
  loading(state) {
    return state.loading;
  },
  browseId(state) {
    return state.browse_id;
  },
  skills(state) {
    return state.skills;
  },
  interests(state) {
    return state.interests;
  },
};

const actions = {
  initializeBrowseTasks({ commit }) {
    const userToken = this.getters['auth/userToken'];
    return initializeBrowseTasks(userToken)
      .then(({ data }) => {
        const browseId = get(data, '[1].data.details.browse_id');
        commit(GET_BROWSE_ID, browseId);
      });
  },
  getBrowseTaskSkills({ commit, state }) {
    commit(BROWSE_LOADER, true);
    const userToken = this.getters['auth/userToken'];
    const browseId = state.browse_id;
    getBrowseTaskSkills(userToken, browseId)
      .then(({ data }) => {
        const skills = get(data, '[1].data.details.skills_data');
        commit(GET_BROWSE_TASK_SKILLS, skills);
        commit(BROWSE_LOADER, false);
      });
  },
  getBrowseTaskInterests({ commit, state }) {
    const userToken = this.getters['auth/userToken'];
    const browseId = state.browse_id;
    commit(BROWSE_LOADER, true);

    getBrowseTaskInterests(userToken, browseId)
      .then(({ data }) => {
        commit(BROWSE_LOADER, false);
        const interests = get(data, '[1].data.details.interest_data');
        commit(GET_BROWSE_TASK_INTERESTS, interests);
      });
  },
  browseTaskEdit(_, values) {
    const userToken = this.getters['auth/userToken'];
    return browseTaskEdit(userToken, values);
  },
  resetBrowseState({ commit }) {
    commit(GET_BROWSE_TASK_SKILLS, []);
    commit(GET_BROWSE_TASK_INTERESTS, []);
  },
};


const mutations = {
  [GET_BROWSE_ID](state, browseId) {
    state.browse_id = browseId;
  },
  [GET_BROWSE_TASK_SKILLS](state, skills) {
    state.skills = skills;
  },
  [GET_BROWSE_TASK_INTERESTS](state, interests) {
    state.interests = interests;
  },
  [BROWSE_LOADER](state, value) {
    state.loading = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/browse_tasks.js